import { getIsMobile } from 'src/store/view/selectors';
import { connect } from 'react-redux';
import LabelList from 'src/components/LabelList';
import { getHotelLabels } from '../../store/hotel';

const mapStateToProps = (state) => ({
  labels: getHotelLabels(state),
  isMobile: getIsMobile(state),
});

export default connect(mapStateToProps)(LabelList);
